/** Bộ lọc báo cáo hộ trồng (trên URL): tìm tên/tên thường gọi/SĐT/địa chỉ. */
export interface GrowerReportSearch {
    q?: string
}

export function validateGrowerReportSearch(
    raw: Record<string, unknown>,
): GrowerReportSearch {
    return {
        q: typeof raw.q === 'string' && raw.q.trim() ? raw.q : undefined,
    }
}
